export default "__VITE_ASSET__eLyxqvaE__"